import { useSelector } from 'react-redux';
import { DEFAULT_SECONDARY_COLOUR } from 'shared/constants/styleConstants';

export default function CruiseIcon({ classNames, styleObject, heightWidth }) {
  const { theme } = useSelector((state) => state.ui);

  return (
    <div className={classNames} style={styleObject}>
      <svg
        width={heightWidth || '50'}
        height={heightWidth || '50'}
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ zIndex: 999 }}
      >
        <circle
          cx="25"
          cy="25"
          r="25"
          fill={theme.brandColour || DEFAULT_SECONDARY_COLOUR}
        />
        <path
          d="M32.3002 33.1818C31.1188 33.1818 29.9375 32.7545 28.9006 31.9818C26.8268 33.5364 24.1751 33.5364 22.1014 31.9818C21.0645 32.7545 19.8831 33.1818 18.7018 33.1818H17.002V35H18.7018C19.8746 35 21.0305 34.6818 22.1014 34.1C24.2431 35.2727 26.7588 35.2727 28.9006 34.1C29.9715 34.6909 31.1273 35 32.3002 35H34V33.1818H32.3002ZM18.6593 31.3636H18.7018C20.0616 31.3636 21.2685 30.5636 22.1014 29.5455C22.9343 30.5636 24.1411 31.3636 25.501 31.3636C26.8608 31.3636 28.0677 30.5636 28.9006 29.5455C29.7335 30.5636 30.9404 31.3636 32.3002 31.3636H32.3427L33.949 25.2909C34.017 25.0545 34 24.8 33.898 24.5818C33.796 24.3636 33.609 24.2 33.3881 24.1273L32.3002 23.7455V19.5455C32.3002 18.5455 31.5353 17.7273 30.6004 17.7273H28.0507V15H22.9513V17.7273H20.4016C19.4667 17.7273 18.7018 18.5455 18.7018 19.5455V23.7455L17.6054 24.1273C17.3844 24.2 17.1975 24.3636 17.0955 24.5818C16.9935 24.8 16.968 25.0545 17.0445 25.2909L18.6593 31.3636ZM20.4016 19.5455H30.6004V23.1545L25.501 21.3636L20.4016 23.1545V19.5455Z"
          fill="white"
        />
      </svg>
    </div>
  );
}
